export default "__VITE_ASSET__B0aOdMEK__"